var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoLanguage24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_language24x24",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(6.731 7.267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M5.022,4.6H4.756L4.4,6.467h.978Z",
    transform: "translate(-4.4 -4.6)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(14.881 11.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M7.5,6a4.712,4.712,0,0,0,.711,1.334A3.348,3.348,0,0,0,9.011,6Z",
    transform: "translate(-7.5 -6)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(10.554 5.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M12.835,4.1H7.056L8.3,13.88a1.552,1.552,0,0,1-.356,1.067L5.9,17.259h7.024a1.4,1.4,0,0,0,1.423-1.423V5.523A1.542,1.542,0,0,0,12.835,4.1Zm0,5.157h-.089A6.715,6.715,0,0,1,11.59,11.3c.356.356.711.533,1.067.889a.445.445,0,1,1-.533.711,13.068,13.068,0,0,1-1.156-.889,5.708,5.708,0,0,1-1.156.889.445.445,0,1,1-.533-.711,9.417,9.417,0,0,0,1.067-.889A5.038,5.038,0,0,1,9.279,9.257H9.1a.5.5,0,0,1-.445-.533c0-.178.178-.356.445-.445h1.423V7.834a.5.5,0,0,1,.533-.445c.178,0,.356.178.445.445v.445h1.423a.5.5,0,0,1,.445.533.563.563,0,0,1-.533.445Z",
    transform: "translate(-5.9 -4.1)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M10.646,4.245A1.437,1.437,0,0,0,9.224,3h-4.8A1.4,1.4,0,0,0,3,4.423v10.4a1.4,1.4,0,0,0,1.423,1.423H11.8c.178-.178.267-.267.267-.445C12.069,15.714,10.646,4.245,10.646,4.245ZM8.779,11.98a.392.392,0,0,1-.533-.356L7.89,10.113H6.556L6.29,11.624a.459.459,0,0,1-.622.267.488.488,0,0,1-.356-.533L6.29,6.645c0-.178.267-.356.445-.356h.978a.407.407,0,0,1,.445.356l.978,4.712A.748.748,0,0,1,8.779,11.98Z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(8.487 17.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M5.1,8.289v.622a1.417,1.417,0,0,0,.8,1.067L7.5,8.2Z",
    transform: "translate(-5.1 -8.2)",
    fill: "#999"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoLanguage24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_language24x24.7119ddc428fa6d1bc6010b09200467c5.svg";